import { PageTitleService } from 'app/core/page-title/page-title.service';
import { MensagensService } from 'app/services/mensagens.service';
import { SiteService } from 'app/services/site.service';
import { AcessoRestritoSiteService } from 'app/services/acesso-restrito.service';
import { DownloadService } from 'app/services/download.service';
import { ValidadorService } from 'app/services/validador.service';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbDate, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import * as moment from 'moment';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-pesquisa-satisfacao-site-v2',
  templateUrl: './pesquisa-satisfacao-site-v2.component.html',
  styleUrls: ['./pesquisa-satisfacao-site-v2.component.css']
})
export class PesquisaSatisfacaoSiteV2Component implements OnInit {
  emPesquisa = true;
  formGroup: FormGroup;
  erromessage = '';
  erroresposta = '';
  inSpinner = false;
  token = '';
  pesquisa: any;
  escolheuOutro = false;

  constructor(
    private pageTitleService: PageTitleService,
    private formBuilder: FormBuilder,
    public validadorService: ValidadorService,
    public servico: SiteService,
    private _activatedRoute: ActivatedRoute,
    public mensagensService: MensagensService
  ) {
    this.pageTitleService.setTitle('Pesquisa de satisfação Derminas');
    this.pageTitleService.setSubTitle('');
    const usuario = JSON.parse(localStorage.getItem('localUsuarioDerminas'));
    console.log('------------>', usuario);
    let cpf = '';
    let nomeUsuario = '';
    if (!!usuario) {
      cpf = usuario.cpf;
      nomeUsuario = usuario.nomeUsuario;
    }

    this.formGroup = this.formBuilder.group({
      tipoParticipante: [null, Validators.required],
      resposta1: [null, Validators.required],
      resposta2: [null, Validators.required],
      // resposta3: [null, Validators.required],
      resposta4: [null, Validators.required],
      // resposta5: [null, Validators.required],
      resposta6: [null, Validators.required],
      resposta7: [null, Validators.required],
      resposta8: [null, Validators.required],
      resposta9: [null, Validators.required],
      pergunta3: [null],
      pergunta5: [null],
      pergunta1Outro: [null],
      nomeParticipante: nomeUsuario,
      cpf: cpf,
      idPesquisa: '0',
      versao: 'v2',
    });
  }

  ngOnInit(): void {
    const usuario = JSON.parse(localStorage.getItem('localUsuarioDerminas'));
    if (!!usuario) {
      this.formGroup.patchValue({
        cpf: usuario.cpf,
        nomeParticipante: usuario.nomeUsuario
      });
    }
  }

  abrirLink(url: string) {
    window.open(url, '_blank');
  }

  selecionar(tipo) {
    this.formGroup.patchValue({
      tipoParticipante: tipo
    });
  }

  respostaOutro(value) {
    if (value === '12') {
      this.escolheuOutro = true;
    } else {
      this.escolheuOutro = false;
    }
  }

  toTopPosition() {
    // Hack: Scrolls to top of Page after page view initialized
    let top = document.getElementById('toperror');
    if (top !== null) {
      top.scrollIntoView();
      top = null;
    }
  }

  salvar() {
    this.erromessage = '';
    if (this.formGroup.valid) {
      this.inSpinner = true;
      this.servico.respondersite(this.formGroup.value)
        .pipe(finalize(() => {
          this.inSpinner = false;
        }))
        .subscribe(result => {
          this.emPesquisa = false;
          this.formGroup.reset();
          this.formGroup.markAsUntouched();
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'A Derminas agradeçe pela sua participação!',
            showConfirmButton: false,
            timer: 5000
          });
        },
          err => {
            this.inSpinner = false;
            this.erromessage = this.mensagensService.recuperarMensagemErro(err);
          });
    } else {
      if (this.formGroup.get('resposta1').status === 'INVALID') {
        this.formGroup.get('resposta1').setErrors({ selecionarOpcao: true });
      }
      if (this.formGroup.get('resposta2').status === 'INVALID') {
        this.formGroup.get('resposta2').setErrors({ selecionarOpcao: true });
      }
      if (this.formGroup.get('resposta4').status === 'INVALID') {
        this.formGroup.get('resposta4').setErrors({ selecionarOpcao: true });
      }
      if (this.formGroup.get('resposta6').status === 'INVALID') {
        this.formGroup.get('resposta6').setErrors({ selecionarOpcao: true });
      }
      if (this.formGroup.get('resposta7').status === 'INVALID') {
        this.formGroup.get('resposta7').setErrors({ selecionarOpcao: true });
      }
      if (this.formGroup.get('resposta8').status === 'INVALID') {
        this.formGroup.get('resposta8').setErrors({ selecionarOpcao: true });
      }
      if (this.formGroup.get('resposta9').status === 'INVALID') {
        this.formGroup.get('resposta9').setErrors({ selecionarOpcao: true });
      }
      if (this.formGroup.get('tipoParticipante').status === 'INVALID') {
        this.formGroup.get('tipoParticipante').setErrors({ selecionarOpcao: true });
      }

      // if (this.formGroup.get('recaptcha').invalid) {
      //   const element: HTMLElement = document.querySelector('#rc-anchor-container') as HTMLElement;
      //   if (element !== null && element !== undefined) {
      //     element.classList.add('captha-erro');
      //   }
      // }
      this.toTopPosition();
      this.inSpinner = false;
      this.validadorService.validarTodosCampos(this.formGroup);
      this.erromessage = 'Selecione os campos solicitados';
    }
  }

}

